export const getErrorCode = (err: unknown): string | null => {
  if (err && typeof err === 'object') {
    const code = (err as any)?.response?.data?.error;
    if (typeof code === 'string') return code;
  }
  return null;
};

export const getErrorMessage = (err: unknown): string => {
  if (typeof err === "string") return err;

  if (err && typeof err === "object") {
    const anyErr = err as any;

    const message =
      anyErr?.response?.data?.message ||
      anyErr?.message;

    if (Array.isArray(message)) return message.join(", ");
    if (typeof message === "string") return message;
  }

  return "Unexpected error";
};
